export default __webpack_public_path__ + "static/media/hht2_ep20_timeline_q01_a.ac31b8f5.png";